
export default {
    name: 'CustomTooltip',

    props: {
        content: {
            type: String,
            required: true,
            default: '',
        },
        isShown: {
            type: Boolean,
            default: false,
        },

        tooltipWidth: {
            type: Number,
            default: 300,
        },
        title: {
            type: String,
            default: '',
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: '',
        },
        onMouseLeave: {
            type: Function,
            default: () => {},
        },
    },
    computed: {
        tooltipStyle() {
            return this.isMobile
                ? {}
                : {
                      width: `${this.tooltipWidth}px`,
                  }
        },
    },

    methods: {
        closeClicked() {
            this.$emit('close')
        },
        getArrowRef() {
            return this.$refs.arrowRef
        },
        getFloatingRef() {
            return this.$refs[this.id + 'FloatingRef']
        },
        handleMouseLeave() {
            this.onMouseLeave()
        },
        getHiddenDivRef() {
            return this.$refs.hiddenDivRef
        },
    },
}
